const initTableOfContent = () => {
  const tableOfContent = document.querySelector('.wp-block-rank-math-toc-block');
  const navigation = document.querySelector('.gg-navigation');
  const tocDropdownButtonClass = '.toc-dropdown-button';
  const tocDropdownContentClass = '.toc-dropdown-content';
  const tocDropdownCoverClass = '.toc-dropdown-cover a';
  const tocListClass = '.toc-list a';
  const hiddenClass = 'hidden';
  const currentClass = 'current';
  const fixedPositionClass = 'fixed-position';
  const hiddenTocClass = 'hidden-toc';
  const bufferDistance = 200;
  const scrollTimeout = 100;
  const scrollBehavior = 'smooth';
  const offsetAdjustment = 50;
  const mobileWidth = 1024;
  const sectionClass = '.section-class';
  const tocBlockClass = '.toc-dropdown-custom';
  const tocBlockColFixedClass = '.gg-blog-detail__col-fixed';
  const blogDetailClass = '.gg-blog-detail';
  const headingSelector = 'h1, h2, h3';
  const tocSpaceMbSelector = '.gg-blog-detail__col-fixed .wp-block-rank-math-toc-block';
  const attributeFilter = ['class'];
  const mutationObserverConfig = { attributes: true, attributeFilter };

  let isScrollTriggeredByClick = false;
  let adjustOffset = 0;
  let navigationHeight = 0;

  if (!tableOfContent || !navigation) return;

  const tocBlock = document.querySelector(tocBlockClass);

  const updateTocBlockTop = () => {
    if (navigation.classList.contains(hiddenClass)) {
      tocBlock.style.top = `10px`;
    } else {
      navigationHeight = navigation.offsetHeight;
      tocBlock.style.top = `${navigationHeight}px`;
    }
  };

  updateTocBlockTop();

  const observer = new MutationObserver(updateTocBlockTop);
  observer.observe(navigation, mutationObserverConfig);

  const resizeObserver = new ResizeObserver(updateTocBlockTop);
  resizeObserver.observe(navigation);

  const scrollToElement = (selector, offset) => {
    const element = selector.startsWith('#') ? document.getElementById(selector.substring(1)) : document.querySelector(selector);
    if (element) {
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      const elementPosition = element.getBoundingClientRect().top + scrollPosition;
      const tocSpaceMb = document.querySelector(tocSpaceMbSelector);
      const spaceMb = tocSpaceMb ? tocSpaceMb.offsetHeight + offsetAdjustment : 0;
      const offsetPosition = elementPosition - offset - (window.innerWidth < mobileWidth ? spaceMb : 0);

      window.scrollTo({ top: offsetPosition, behavior: scrollBehavior });
    }
  };

  const updateDropdownButton = (text) => {
    const dropdownButton = document.querySelector(tocDropdownButtonClass);
    if (dropdownButton) dropdownButton.textContent = text.trim();
  };

  tableOfContent.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', event => {
      event.preventDefault();
      adjustOffset = navigation ? navigation.offsetHeight + offsetAdjustment : 0;
      const target = link.getAttribute('href');

      updateDropdownButton(link.textContent);
      if (target) setTimeout(() => scrollToElement(target, adjustOffset), scrollTimeout);
    });
  });

  const blog = document.querySelector(blogDetailClass);
  if (blog) {
    blog.querySelectorAll(headingSelector).forEach(heading => {
      const id = heading.textContent.trim()
        .replace(/’s/g, " s")
        .replace(/'s/g, " s")
        .toLowerCase()
        .replace(/[^a-zA-Z0-9-\s]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');
      heading.setAttribute('id', id);
    });
  }

  tableOfContent.querySelectorAll('a').forEach(link => {
    if (link.textContent.includes('’s')) {
      const id = '#' + link.textContent
        .replace(/’s/g, " s")
        .replace(/'s/g, " s")
        .toLowerCase()
        .replace(/[^a-zA-Z0-9-\s]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');
      link.setAttribute('href', id);
    }
  });

  const tocBlockColFixed = document.querySelector(tocBlockColFixedClass);
  const dropdownButton = document.querySelector(tocDropdownButtonClass);
  const dropdownContent = document.querySelector(tocDropdownContentClass);
  const sections = document.querySelectorAll(tocDropdownCoverClass);
  const tocListItems = document.querySelectorAll(tocListClass);

  if (tocBlockColFixed) {
    tocBlockColFixed.style.minHeight = `${tocBlockColFixed.getBoundingClientRect().height}px`;
    tocBlockColFixed.style.maxHeight = `${tocBlockColFixed.getBoundingClientRect().height}px`;
  }

  const tocOriginalOffsetTop = tocBlock ? tocBlock.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) : 0;
  const parentSection = tocBlock?.closest('section') || document.querySelector(sectionClass);
  const sectionTop = parentSection ? parentSection.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) : 0;
  const sectionBottom = parentSection ? sectionTop + parentSection.offsetHeight : 0;

  dropdownButton?.addEventListener('click', () => {
    dropdownContent.style.display = dropdownContent.style.display === 'block' ? 'none' : 'block';
  });

  window.addEventListener('click', event => {
    if (!event.target.matches(tocDropdownButtonClass)) {
      dropdownContent.style.display = 'none';
    }
  });

  sections.forEach((link, index) => {
    link.addEventListener('click', e => {
      e.preventDefault();
      isScrollTriggeredByClick = true;

      sections.forEach(l => l.classList.remove(currentClass));
      tocListItems.forEach(item => item.classList.remove(currentClass));

      link.classList.add(currentClass);
      tocListItems[index].classList.add(currentClass);

      updateDropdownButton(link.textContent);

      const targetSection = link.getAttribute('href');
      if (targetSection) {
        const targetElement = document.querySelector(targetSection);
        if (!targetElement) return;

        const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        const targetPosition = targetElement.getBoundingClientRect().top + currentScrollPosition;

        if (targetPosition > currentScrollPosition) {
          adjustOffset = offsetAdjustment;
        } else {
          adjustOffset = navigation.offsetHeight + offsetAdjustment;
        }

        setTimeout(() => {
          scrollToElement(targetSection, adjustOffset);
          setTimeout(() => {
            isScrollTriggeredByClick = false;
          }, 800);
        }, scrollTimeout);
      }

      dropdownContent.style.display = 'none';
    });
  });

  window.addEventListener('scroll', () => {
    if (window.innerWidth < mobileWidth) {
      let currentSection = null;
      const tocBlockPosition = tocBlock.getBoundingClientRect();
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

      sections.forEach((link, index) => {
        const section = document.querySelector(link.getAttribute('href'));
        if (!section) return;

        const sectionPosition = section.getBoundingClientRect();

        if (isScrollTriggeredByClick) {
          if (sectionPosition.top <= tocBlockPosition.bottom + bufferDistance) {
            currentSection = link;
            sections.forEach(l => l.classList.remove(currentClass));
            tocListItems.forEach(item => item.classList.remove(currentClass));
            tocListItems[index].classList.add(currentClass);
            sections[index].classList.add(currentClass);
          }
        } else {
          if (sectionPosition.top <= tocBlockPosition.bottom) {
            currentSection = link;
            sections.forEach(l => l.classList.remove(currentClass));
            tocListItems.forEach(item => item.classList.remove(currentClass));
            tocListItems[index].classList.add(currentClass);
            sections[index].classList.add(currentClass);
          }
        }
      });

      if (currentSection) updateDropdownButton(currentSection.textContent);

      if (scrollPosition >= sectionBottom - 300) {
        tocBlock.classList.add(hiddenTocClass);
      } else {
        tocBlock.classList.remove(hiddenTocClass);
      }

      if (navigation.classList.contains(hiddenClass)) {
        if (scrollPosition >= tocOriginalOffsetTop - (navigationHeight + offsetAdjustment)) {
          tocBlock.classList.add(fixedPositionClass);
        } else {
          tocBlock.classList.remove(fixedPositionClass);
        }
      } else {
        if (scrollPosition >= tocOriginalOffsetTop - offsetAdjustment) {
          tocBlock.classList.add(fixedPositionClass);
        } else {
          tocBlock.classList.remove(fixedPositionClass);
        }
      }
    } else {
      tocListItems.forEach((link, index) => {
        const tocListItem = document.querySelector(link.getAttribute('href'));
        if (!tocListItem) return;

        const tocListItemPosition = tocListItem.getBoundingClientRect();

        if (tocListItemPosition.top <= navigationHeight + bufferDistance) {
          tocListItems.forEach(l => l.classList.remove(currentClass));
          tocListItems.forEach(item => item.classList.remove(currentClass));
          tocListItems[index].classList.add(currentClass);
          tocListItems[index].classList.add(currentClass);
        }
      });
    }
  });
};

export default initTableOfContent;
